export const PERSISTENT_STORE_NAMES = {
  auth: "auth-storage",
  idToken: "ID_STORAGE_KEY",
  onboarding: "onboarding",
  preferences: "preferences",
} as const;
